<template>
  <AppModal
    :visible="visible"
    persistent
    :close-button="false"
    :show-title="!incorrect"
  >
    <template #title>
      <VerifyModalTitle
        :executed="executed"
        @close="close"
      />
    </template>
    <template #content>
      <VerifyModalIncorrect
        v-if="incorrect"
        :type="type"
        :response="response"
      />
      <VerifyModalVerify
        v-else
        :response="response"
        :executed="executed"
      />
    </template>
    <template #actions>
      <VerifyModalActions
        :incorrect="incorrect"
        :executed="executed"
        @close="close"
        @upload="$emit('upload')"
      />
    </template>
  </AppModal>
</template>

<script>
import VerifyModalIncorrect from '@/components/ManageSwr/VerifyModal/Content/VerifyModalIncorrect';
import VerifyModalVerify from '@/components/ManageSwr/VerifyModal/Content/VerifyModalVerify';
import VerifyModalActions from '@/components/ManageSwr/VerifyModal/VerifyModalActions';
import VerifyModalTitle from '@/components/ManageSwr/VerifyModal/VerifyModalTitle';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'VerifyModal',
    components: {
        VerifyModalTitle,
        VerifyModalIncorrect,
        VerifyModalActions,
        VerifyModalVerify,
        AppModal
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        response: {
            type: Object,
            required: true
        },
        executed: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            required: true
        }
    },
    computed: {
        hasRemovedRows () {
            return (
                Object.prototype.hasOwnProperty.call(this.response, 'removed_rows_count') &&
        this.response.removed_rows_count > 0
            );
        },
        incorrect () {
            return (
                (this.response.added_rows_count === 0 && !this.hasRemovedRows) ||
        (this.response && this.response.responseCode != null)
            );
        }
    },
    methods: {
        close () {
            this.$emit('close');
        }
    }
};
</script>

<style scoped></style>
